import cxs from 'cxs';
import { COLOURS } from '../../../common/styles/vars';

export const CLOSABLE_PAGE_HEADER = ({ backgroundImage }) => cxs({
  width: '100%',
  position: 'fixed',
  top: 0,
  left: 0,
  height: '125px',
  display: 'flex',
  flexDirection: 'column',
  zIndex: 2,
  backgroundImage: backgroundImage ?
  '' :
  `linear-gradient(to bottom, ${COLOURS.mono.white}, ${COLOURS.mono.white75})`
});

export const CLOSE_BUTTON = ({ backgroundImage }) => cxs({
  alignSelf: 'flex-end',
  marginTop: '22px',
  marginRight: '30px',
  color: backgroundImage && COLOURS.mono.white
});